/// <amd-module name="Artifacts/Cargo/helpers/InstructionsHelper" />
import { IPackageVersion } from "Artifacts/Root/types";

export function getCopyInstallCommand(pkgName: string, pkgVersion: IPackageVersion): string {
  return `cargo install ${pkgName}==${pkgVersion.version}`;
}
